import { JoinType } from 'core/models/report-builder/report-builder';

export const enum Operators {
    EQUAL_TO = 'Equal to',
    GREATER_THAN = 'Greater than',
    LESS_THAN = 'Less than',
    GREATER_THAN_OR_EQUAL_TO = 'Greater than or Equal to',
    LESS_THAN_OR_EQUAL_TO = 'Less than or Equal to',
    NOT_EQUAL_TO = 'Not Equal to'
}
export const JoinOptions = [
  {
    label: 'Left Outer Join',
    value: JoinType.LEFT,
  },
  {
    label: 'Inner Join',
    value: JoinType.INNER,
  },
  {
    label: 'Right Outer Join',
    value: JoinType.RIGHT,
  },
  {
    label: 'Full Outer Join',
    value: JoinType.FULL,
  },
  {
    label: 'Cross Join',
    value: JoinType.CROSS,
  },
  {
    label: 'Union',
    value: JoinType.UNION,
  },
  {
    label: 'Union All',
    value: JoinType.UNIONALL,
  },
];

export const OperatorOptions = [
  {
    label: 'Equal to',
    value: 'Equal to',
  },
  {
    label: 'Greater than',
    value: 'Greater than',
  },
  {
    label: 'Less than',
    value: 'Less than',
  },
  {
    label: 'Greater than or Equal to',
    value: 'Greater than or Equal to',
  },
  {
    label: 'Less than or Equal to',
    value: 'Less than or Equal to',
  },
  {
    label: 'Not Equal to',
    value: 'Not Equal to',
  },
];
